<template>
  <div class="deck-container">
    <div id="map" ref="map"></div>
    <canvas
      id="deck-canvas"
      ref="canvas"
      @contextmenu.prevent="
        () => {
          return false;
        }
      "
    ></canvas>
  </div>
</template>

<script>
import { Deck, FlyToInterpolator } from "@deck.gl/core";
import mapboxgl from "mapbox-gl";
import view from "@deck.gl/core/dist/es5/views/view";
// const hack = deck;

export default {
  props: {
    layers: Array,
    latitude: Number,
    longitude: Number,
    pitch: Number,
    bearing: Number,
    zoom: Number,
    accessToken: String,
    mapStyle: String,
    updateViewStateOnLayersChange: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    viewState() {
      return {
        latitude: this.latitude,
        longitude: this.longitude,
        pitch: this.pitch || 0,
        bearing: this.bearing || 0,
        zoom: this.zoom || 12,
      };
    },
    location() {
      return {
        latitude: this.latitude,
        longitude: this.longitude,
      };
    },
  },
  methods: {
    /**
     * Passes the list of all the layers to deck.gl renderer
     */
    renderLayers() {
      if (this.deck && this.layers && this.layers.length > 0) {
        this.deck.setProps({
          layers: this.layers,
          viewState: {
            latitude: this.stateTracker.latitude,
            longitude: this.stateTracker.longitude,
            zoom: this.stateTracker.zoom,
            pitch: this.stateTracker.pitch,
            bearing: this.stateTracker.bearing,
          },
        });
      }
      // update the map's viewstate
      if (this.updateViewStateOnLayersChange) {
        this.updateViewState(this.viewState); // This is buggy
      }
    },
    updateStateTracker(viewState, shouldUpdate) {
      Object.keys(this.stateTracker).forEach(key => {
        if (viewState[key]) {
          this.stateTracker[key] = viewState[key];
        }
      });
      if (shouldUpdate) {
        this.updateViewState(this.stateTracker);
      }
    },
    /**
     * Keeps track of the viewState updates and saves it in the state
     */
    updateViewState(viewState) {
      this.deck.setProps({
        viewState: {
          ...viewState,
          transitionDuration: 500,
          // transitionInterpolator: new FlyToInterpolator()
        },
      });
      this.updateMapViewState(viewState);
    },
    updateMapViewState(viewState) {
      this.map.jumpTo({
        center: [viewState.longitude, viewState.latitude],
        zoom: viewState.zoom,
        bearing: viewState.bearing,
        pitch: viewState.pitch,
      });
    },
  },
  watch: {
    /**
     * Watch for layer changes
     * ReRender the layers if there are any new changes
     */
    layers() {
      this.renderLayers();
    },
    location(value) {
      // Whenever the passed latitude or longitude changes, reset the viewState:
      this.updateStateTracker(
        {
          latitude: this.latitude,
          longitude: this.longitude,
          zoom: this.zoom,
        },
        true
      );
    },
    pitch(value) {
      this.updateStateTracker({ pitch: value }, true);
    },
    bearing(value) {
      this.updateStateTracker({ bearing: value }, true);
    },
    zoom(value) {
      this.updateStateTracker({ zoom: value }, true);
    },
  },
  created() {
    this.map = null;
    this.deck = null;
    this.stateTracker = {
      latitude: this.latitude,
      longitude: this.longitude,
      pitch: this.pitch || 0,
      bearing: this.bearing || 0,
      zoom: this.zoom || 12,
    };
  },
  mounted() {
    this.map = new mapboxgl.Map({
      accessToken: this.accessToken,
      container: this.$refs.map,
      interactive: false,
      style:
        this.mapStyle || "mapbox://styles/haxzie/ck52gt5wl4t521cqh8fq9kbme",
      center: [this.viewState.longitude, this.viewState.latitude],
      zoom: this.viewState.zoom,
      pitch: this.viewState.pitch,
      bearing: this.viewState.bearing,
    });

    this.deck = new Deck({
      mapboxApiAccessToken:
        "pk.eyJ1Ijoic3ltYm9saXgiLCJhIjoiY2prM2dqNWhiMTMwYzNrcnRmY2NnajI1cCJ9.g8-mLbubDPgqUv-CBx65Xg",
      canvas: this.$refs.canvas,
      width: "100%",
      height: "100%",
      initialViewState: this.viewState,
      controller: true,
      onViewStateChange: ({ viewState }) => {
        this.updateMapViewState(viewState);
        this.updateStateTracker(viewState, false);
      },
      onClick: (info, event) => {
        this.$emit("onClick", info, event);
      },
      onDragStart: (info, event) => {
        this.$emit("onDragStart", info, event);
      },
    });

    this.renderLayers();
  },
  beforeDestroy() {
    this.deck.finalize();
  },
};
</script>

<style scoped>
.deck-container {
  width: 100%;
  height: 100%;
  position: relative;
}
#map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #e5e9ec;
  overflow: hidden;
}
#deck-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
